"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DndContext = void 0;
var _react = require("react");
const DndContext = (0, _react).createContext({
    dragDropManager: undefined
});
exports.DndContext = DndContext;

//# sourceMappingURL=DndContext.js.map